import { useEffect, useState } from "react";
import {
  Input,
  Button,
  FormField,
  SpaceBetween,
  Form,
  Select,
  Container,
} from "@cloudscape-design/components-themed";
import { isLengthValid } from "../../utils/inputValidation";
import { getMessage } from "../../features/error/messages";
import { LABELS, SELECT_BLANK } from "./constants";
import { useAppDispatch } from "../../app/hook";
import { createSearchCondition } from "../../features/slices/industry-conversion-search";
import { useNavigate } from "react-router-dom";
import { CommercialIndustries } from "../../features/api-interfaces";
import { useGetCommercialIndustriesQuery } from "../../features/api";
import { DivisionDict } from "../default-constants";
import { getIndustryConversionsItems } from "../industry-conversion/constants";

const addBlank = (list: DivisionDict[]) => {
  if (list) list.unshift(SELECT_BLANK as DivisionDict);
  return list;
};

/* 
業態変換一覧の検索条件
 */
const SearchBar = () => {
  const navigate = useNavigate();

  // 変換後業態コード
  const [conversionAfterIndustryCode, setConversionAfterIndustryCode] =
    useState({ value: "" });

  // 変換後業態コード一覧
  const [afterConversionList, setAfterConversionList] =
    useState<DivisionDict[]>();

  // エラーメッセージ
  const [errText, setErrText] = useState<string>();

  // 商用反映済みの業態情報を取得する
  const divisionData1 = useGetCommercialIndustriesQuery();
  const afterConversionItems = divisionData1?.data as CommercialIndustries[];
  const industryAfterConversionCodeItems: DivisionDict[] = addBlank(
    getIndustryConversionsItems(afterConversionItems)
  );

  useEffect(() => {
    setAfterConversionList(industryAfterConversionCodeItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divisionData1]);

  // エラーメッセージ関連
  const [
    industryAfterConversionNameErrorMsg,
    setConversionAfterIndustryNameErrorMsg,
  ] = useState("");

  // 変換後業態名
  const [conversionAfterIndustryName, setConversionAfterIndustryName] =
    useState("");

  const dispatch = useAppDispatch();

  // 変換後業態名のチェック
  const conversionAfterIndustryNameOnChange = (
    conversionAfterIndustryName: string
  ) => {
    // 文字数チェック
    if (!isLengthValid(conversionAfterIndustryName, 100)) {
      setConversionAfterIndustryNameErrorMsg(
        getMessage("KGRERR024", LABELS.AFTER_CONVERSION_NAME, 100).label
      );

      return false;
    }

    // ここまで来たら問題ないのでエラーを消す
    setConversionAfterIndustryNameErrorMsg("");

    return true;
  };

  // 入力チェック
  const validateInputs = () => {
    if (!conversionAfterIndustryNameOnChange(conversionAfterIndustryName)) {
      return false;
    }

    return true;
  };

  // 検索ボタン押下時処理
  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // バリデーションチェック
    const result = validateInputs();

    if (result) {
      dispatch(
        createSearchCondition({
          conversionAfterIndustryCode: conversionAfterIndustryCode.value,
          conversionAfterIndustryName: conversionAfterIndustryName,
          timestamp: new Date().getTime(),
        })
      );
    }
    // エラーメッセージクリア
    setErrText("");
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal">{LABELS.HOLDINGS_SEARCH}</Button>
          </SpaceBetween>
        }
        errorText={errText}
      >
        <Container>
          <SpaceBetween direction="vertical" size="l">
            <FormField>
              <Button
                onClick={() => {
                  navigate("/industry-conversion/registry");
                }}
              >
                {LABELS.INDUSTRYCONVERSION_REGISTRATION}
              </Button>
            </FormField>
            <FormField label={LABELS.AFTER_CONVERSION_CODE}>
              <Select
                selectedOption={conversionAfterIndustryCode}
                options={afterConversionList}
                filteringType="auto"
                onChange={(event: any) => {
                  setConversionAfterIndustryCode(event.detail.selectedOption);
                }}
              />
            </FormField>
            <FormField
              label={LABELS.AFTER_CONVERSION_NAME}
              errorText={industryAfterConversionNameErrorMsg}
            >
              <Input
                name="conversionAfterIndustryName"
                value={conversionAfterIndustryName}
                onChange={(e) => {
                  setConversionAfterIndustryName(e.detail.value);
                  conversionAfterIndustryNameOnChange(e.detail.value);
                }}
              />
            </FormField>
          </SpaceBetween>
        </Container>
      </Form>
    </form>
  );
};

export default SearchBar;
